import { EmoticonPoopIcon } from './EmoticonPoopIcon';

/**
 * author: Austin Andrews
 * id 968319FB-0E94-4F04-A6D8-9E71DF200E1F
 * name emoticon-poop
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-poop.svg
 * tags
 * - Emoji 
 */
export const EmojiPoopIcon = EmoticonPoopIcon;
export default EmojiPoopIcon